import { GramPostProps } from "../../../Components/TheGramApp/TheGramAppInterfaces";

import pic1 from "./BuckinghamTheGramAssets/Post-01.webp";
import pic2 from "./BuckinghamTheGramAssets/Post-02-nofireworks.webp";
import profilePic1 from "./BuckinghamTheGramAssets/ProfilePic-01.webp";
import profilePic2 from "./BuckinghamTheGramAssets/ProfilePic-02.webp";

export const BuckinghamTheGramContent: GramPostProps[] = [
  {
    Profile: { name: "@Charlotte_Redbury", image: profilePic1 },
    Date: "19 October 2024",
    Image: pic1,
    Likes: "1,320",
    Caption:
      "Taking a breather at Queen Henrietta's 80th! @robfairgrove @adam_johnson12 @marylandsdowne",
    Location: "",
  },
  {
    Profile: { name: "@Alexandra_Wellington", image: profilePic2 },
    Date: "19 October 2024",
    Image: pic2,
    Likes: "3,210",
    Caption: "What a fantastic evening for Queen Henrietta's 80th!",
    Location: "",
  },
];
